

const StoryBoard = () => {
    return(
        <h1>StoryBoard</h1>
    ) 
}

export default StoryBoard;